import { render, staticRenderFns } from "./ruzhitiaogang.vue?vue&type=template&id=9e0e126e&scoped=true"
import script from "./ruzhitiaogang.vue?vue&type=script&lang=js"
export * from "./ruzhitiaogang.vue?vue&type=script&lang=js"
import style0 from "./ruzhitiaogang.vue?vue&type=style&index=0&id=9e0e126e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0e126e",
  null
  
)

export default component.exports